/**
 * Returns a new array with unique elements in the same order as the original array.
 * This can be implemented in one line as array.filter((element, i, arr) => i === arr.indexOf(element)),
 * but it has O(n^2) running time. The implementation below has O(n) running time.
 * @param array to get unique elements from.
 * @param keyOrCallback used to determine uniqueness of elements in the array.
 */
export const uniqueBy = (array, keyOrCallback) => {
    let criterion;
    if (typeof keyOrCallback === 'string') {
        criterion = (element) => (element === null || element === undefined ? element : element[keyOrCallback]);
    }
    else {
        criterion = keyOrCallback;
    }
    const uniqueValues = new Set();
    const orderedUniqueElements = [];
    array.forEach((element) => {
        if (!uniqueValues.has(criterion(element))) {
            orderedUniqueElements.push(element);
            uniqueValues.add(criterion(element));
        }
    });
    return orderedUniqueElements;
};
